<template>
  <div class="p-wrap">
    <div class="p-head">
      <router-link to="/">
        <img class="p-logo fl" src="./../../assets/Pc/boao/logoWhite.png" alt=''>
      </router-link>
      <ul class="clear">
        <li :class="['p-oLi', 'fl', {'p-active':index == $Global.Pc.index, 'p-oLiSix':index==5}]" v-for="(item,index) in headList" :key="index">
          <router-link :to="item.path" v-if='index !== 5'>
            <img v-if="index == 3" :src="item.image" alt="">
            {{item.name}}
          </router-link>
          <el-dropdown v-else placement="top">
            <span class="el-dropdown-link" style="font-size:14px;">
              <a href="https://byh.chinachdu.com/#/loginpanel">{{item.name}}</a>
            </span>
            <!-- <el-dropdown-menu slot="dropdown" class="select-item" placement="bottom-end"> 
              <el-dropdown-item style="text-align:center;padding:5px;color:#666;" v-for="(item,index) in addressList" :key="index">
                <a :href="item.address" style="font-size:13px;">{{item.name}}</a>
              </el-dropdown-item>
            </el-dropdown-menu> -->
          </el-dropdown>
        </li>
      </ul>
    </div>
      <el-carousel class="p-banner" :interval='5000' indicator-position="none" arrow='never' trigger="click" height="332px">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index" :class="{'p-bannerTwo-ce': item.textTwo == ''}">
        <img v-if="index == 1" :src="item.Img" alt="" :class="{'p-centerImg': item.textThree == ''}" @click="skip(12)">
        <img v-else :src="item.Img" alt="" :class="{'p-centerImg': item.textThree == '','p-banner1Img':$route.meta.activeIndex == 0}">
        <div>
          <div class="p-ban-con" :class="{'p-bannerImg':index == 0, 'p-bannerTwo': item.textTwo == ''}">
            <p :class="{'p-bannerTwo-blue': item.textTwo == ''}">{{item.textOne}}
              <br>{{item.textTwo}}
            </p>
            <p :class="{'p-centerTextOne p-marginTwo': item.textTwo == ''}">{{item.textThree}}
              <br>{{item.textFour}}
            </p>
            <p v-if="$route.meta.activeIndex == 2" :class="{'bannerTwo-white': item.textTwo == ''}">{{item.textFive}}
              <br>{{item.textSix}}
            </p>
            <router-link v-track-event="'lookMessage,click'" v-if="$route.meta.activeIndex == 0" :to="{path:'/solution'}">点击查看</router-link>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "PcHead",
  data() {
    return {
      headList: [
        {
          name: "首页",
          path:'/pIndex',
          image:''
        },
        {
          name: "系统性解决方案",
          path:'/solution',
          image:''
        },
        {
          name: "主要产品",
          path:'/product',
          image:''
        },
        {
          name: "博鳌亚洲论坛",
          path:'/homepage',
          image:require('./../../assets/Pc/boao1.png')
        },
        {
          name: "关于我们",
          path:'/about',
          image:''
        },
        {
          name: "登录",
          path:'/',
          image:''
        }
      ],
      showBackground:true,
      activeNum: 0,
      bannerList1: [
        {
          Img:require('./../../assets/Pc/banner1.png'),
          textOne: 'PROFESSIONAL INTERNET SOLUTION',
          textTwo: 'PROVIDER IN HEALTH & MEDICAL DOMAIN',
          textThree: '中国专业的',
          textFour: '互联网医院+全链解决方案供应商',
          textA: ''
        },
        // {
        //   Img: require('./../../assets/Pc/banner3.png'),
        //   textOne: 'SMART AND SECURE MEDICAL SOLUTION',
        //   textTwo: 'GATEWAY TO INTELLIGENT HEALTH CARE',
        //   textThree: '专业安全的医疗解决方案 开启智慧医疗',
        //   textFour: '',
        //   textA: ''
        // },
        // {
        //   Img: require('./../../assets/Pc/banner2.png'),
        //   textOne: 'INTERNET HOSPITAL SYSTEM',
        //   textTwo: '',
        //   textThree: '互联网医院系统',
        //   textFour: '',
        //   textFive:'数据信息统一化+',
        //   textSix:'丰富医疗服务内容 + 拓展医疗资源辐射范围',
        //   textA: ''
        // }
      ],
      bannerList2:[
        {
          Img: require('./../../assets/Pc/banner3.png'),
          textOne: 'SMART AND SECURE MEDICAL SOLUTION',
          textTwo: 'GATEWAY TO INTELLIGENT HEALTH CARE',
          textThree: '专业安全的医疗解决方案',
          textFour: '开启智慧医疗',
          textA: ''
        }
      ],
      bannerList3:[ 
        {
          Img: require('./../../assets/Pc/banner2.png'),
          textOne: 'INTERNET HOSPITAL SYSTEM',
          textTwo: '',
          textThree: '互联网医院系统',
          textFour: '',
          textFive:'数据信息统一化+',
          textSix:'丰富医疗服务内容 + 拓展医疗资源辐射范围',
          textA: ''
        }
      ],
      bannerList:'',
      addressList:[
        {
          name:'佰医平台',
          appCode:'BYH',
          address:'https://byh.chinachdu.com/#/loginpanel'
        },
        {
          name:'航天集团',
          appCode:'HYT',
          address:'https://hyt.chinachdu.com/'
        },
        {
          name:'上饶地区',
          appCode:'SRCITYYS',
          address:'https://syt.chinachdu.com/'
        },
        {
          name:'洛阳地区',
          appCode:'LYCITYYS',
          address:'https://lyt.chinachdu.com/'
        },
        {
          name:'南昌地区',
          appCode:'NCEFY',
          address:'http://ndefy.chinachdu.com/'
        },
        {
          name:'济南地区',
          appCode:'JNS',
          address:'https://jinan.chinachdu.com/'
        },
        {
          name:'上海安达医院',
          appCode:'SHAD',
          address:'https://shad.chinachdu.com/'
        },
        {
          name:'中日友好医院',
          appCode:'ZRYH',
          address:'https://zryh.chinachdu.com/'
        },
        {
          name:'渭北中心医院',
          appCode:'SJWB',
          address:'https://sjwb.chinachdu.com/'
        },
        {
          name:'铜川矿务局中心医院',
          appCode:'SJTCKW',
          address:'https://sjtckw.chinachdu.com/'
        },
        {
          name:'河南科技大学第二附属医院',
          appCode:'HKDEFY',
          address:'https://hkdefy.chinachdu.com/'
        },
        {
          name:'陕西中医院大学第二附属医院',
          appCode:'SZEFY',
          address:'https://szefy.chinachdu.com/'
        },
        {
          name:'郑州大学第一附属医院',
          appCode:'ZDYFY',
          address:'https://zdyfy.chinachdu.com/'
        },
        {
          name:'新乡市第二人民医院',
          appCode:'XXEY',
          address:'https://xxey.chinachdu.com/'
        },
        {
          name:'国药汉江医院',
          appCode:'GYHJ',
          address:'https://gyhj.chinachdu.com/'
        }
      ]
    };
  },
  methods:{
    goSkip(index) {
      this.activeNum = index;
    },
    lookMessage(val){
      this.$router.push({path:'/solution/Index',query:{activeNum: val}})
      this.$uweb.trackEvent(['_trackEvent', '首页banner点击查看', '首页banner点击查看'])
    },
    skip(){
      this.$router.push({path: '/pBoIndex/homepage'})
    },
  },
  mounted() {
    console.log('-')
    if(this.$route.fullPath == '/pIndex'){
      this.bannerList = this.bannerList1
    }else if(this.$route.fullPath == '/solution'){
      this.bannerList = this.bannerList2
    }else if(this.$route.fullPath == '/product'){
      this.bannerList = this.bannerList3
    }
    this.$Global.Pc.title = this.$route.meta.title
    this.$Global.Pc.index = this.$route.meta.activeIndex
  },
});
</script>
<style lang="less" scoped>
.p-wrap {
  position:relative;
  min-height: 590px;
  background: url("./../../assets/Pc/head_one.png");
  background-repeat: no-repeat;
  background-size: 150% 100%;
  background-position:center;
}
.p-head {
  height: 80px;
  line-height: 80px;
  font-size: 14px;
  width: 1000px;
  margin: 0 auto;
  color: white;
  .p-logo {
    width: 158px;
    height: 42px;
    margin: 34px 108px 0 1px;
  }
  .p-oLi {
    display: inline-block;
    padding: 0px 10px;
    line-height: 24px;
    height: 24px;
    margin: 46px 25px 0 0;
    img{
      height:22px;
    }
    a {
      color: white;
      display: block;
      font-family: PingFangSC-Regular;
      font-weight: 400;
    }
    &:nth-child(1) {
      margin-right: 36px;
    }
  }
  .p-active {
    background: white;
    border-radius: 12px;
    a {
      color: #3b6de2;
    }
  }
  .p-oLiSix {
    float: right;
    border-radius: 12px;
    background: #3442c8;
    padding: 0 22px 0 26px;
    a {
      color: #feffff;
      font-size: 16px;
    }
  }
}
.p-center {
  width: 1000px;
  margin: 94px auto 0;
  .p-centerText {
    width: 440px;
    font-size: 20px;
    text-align: left;
    font-family: PangMenZhengDao;
    font-weight: 400;
    margin-left: 28px;
    color: rgba(206, 206, 206, 1);
    line-height: 36px;
    .p-centerTextOne {
      font-size: 24px;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 48px;
    }
    .p-marginTwo{
      margin-top: 30px!important;
    }
    .p-look {
      width: 140px;
      line-height: 30px;
      height: 30px;
      border-radius: 15px;
      background: white;
      color: #3442c8;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      font-family: PingFangSC-Medium;
      margin-top: 30px;
    }
  }
  .p-centerImg {
    margin-left: -16%;
    margin-top:-11%;
    transform: scale(1);
    img {
      width: 610px;
      height: 332px;
    }
  }
}
// .router-link-active{
//   color: white;
//   display: block;
//   width: 100%; height: 100%; border-radius: 12px; padding: 0 30PX;
//   font-family: PingFangSC-Regular;
//   font-weight: 400;
// }
.p-solution{
  font-size:20px!important;
}
.p-banner {
  width: 1000px;
  margin: 0 auto;
  height: 368px;
  overflow: hidden;
  position: relative;
  /deep/.el-carousel__container{
    height: 100%!important;
  }
  img{
    width: 90%;
    height: 86%;
    padding-left: 32%;
  }
  .p-ban-con {
    position: absolute;
    left: 32px;
    top: 90px;
    letter-spacing: 1px;
    p {
      font-size: 20px;
      font-family: PangMenZhengDao;
      line-height: 35px;
      color: #CECECE;
      text-align: left;
      &:nth-child(2) {
        font-size: 24px;
        color: #fff;
        margin: 14px 0 18px;
        font-family: NotoSansHans-Bold;
        font-weight: 500;
        line-height: 48px;
      }
      &:nth-child(3) {
        line-height:48px;
        font-size:20px;
        font-family:NotoSansHans-Bold;
        color:#fff;
      }
    }
    a{
      text-align: center;
      width: 142px; display: block;
      border: 1px solid #FFF;
      background:#fff;
      border-radius: 19px;
      height: 38px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      line-height: 38px;
      color: #3E6AE5;
    }
  }
}
.p-banner-img{
  width: 1200px;
  margin: 0 auto;
  height: 496px;
  overflow: hidden;
  position: relative;
  /deep/.el-carousel__container{
    height: 100%!important;
  }
  img{
    width: 100%; height: 100%; padding-left: 35%;
  }
  .p-ban-con {
    position: absolute;
    left: 32px;
    top: 101px;
    p {
      font-size: 20px;
      font-family: PangMenZhengDao;
      line-height: 35px;
      color: #999;
      text-align: left;
      &:nth-child(2) {
        color: #333333;
        margin: 10px 0 48px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        line-height: 32px;
      }
    }
    a{
      text-align: center;
      width: 208px; display: block;
      border: 1px solid #3576e0;
      border-radius: 19px;
      height: 38px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      line-height: 38px;
      color: #3576e0;
    }
  }
}
// 首页tab切换

.p-con-title {
  width: 1000px;
  margin: 0 auto;
  ul {
    margin-bottom: 61px;
    height: 220px;
    li {
      width: 210px;
      height: 220px;
      background: #fafbff;
      position: relative;
      font-size: 18px;
      border-radius: 4px;
      float: left;
      margin-right: 39px;
      &:nth-child(1) {
        margin-left: 23px;
      }
      &:nth-child(4) {
        margin: 0;
      }
      span {
        font-family: Arial;
        font-weight: 400;
        display: block;
        font-family:PangMenZhengDao;
        color: rgba(53, 118, 224, 1);
        &:nth-child(1) {
          font-size: 30px;
          margin: 17px 0 30px 21px;
          color: rgba(53, 118, 224, 1);

          background: linear-gradient(
            177deg,
            rgba(61, 170, 246, 1) 7.5439453125%,
            rgba(174, 195, 255, 1) 99.5849609375%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        &:nth-child(2) {
          text-align: center;
          font-size: 16px;
          font-family: MicrosoftYaHei;
          margin-bottom: 30px;
        }
        &:nth-child(3) {
          font-size: 14px;
          text-align: center;
          line-height: 30px;
        }
      }
    }
  }
}
.p-con-title-tit {
  height: 24px;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-align: center;
  width: 100%;
  margin: 54px 0 118px;
}
.p-banner1Img{
  margin-left: 5%;
}
.el-dropdown-link{
  color:#fff;
}
.el-dropdown-menu{
  min-width:180px!important;
}
</style>

